import React from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { selectAuthorSuggestionsForCurrentBib } from 'app/selectors/bibs/DiscoverySelector';
import SimilarAuthors from './SimilarAuthors';

export class SimilarAuthorsContainer extends React.PureComponent {
  render() {
    return <SimilarAuthors {...this.props} />;
  }
}

SimilarAuthorsContainer.propTypes = {
  authorSuggestions: ImmutablePropTypes.list.isRequired
};

const mapStateToProps = state => ({
  authorSuggestions: selectAuthorSuggestionsForCurrentBib(state)
});

export default connect(mapStateToProps)(SimilarAuthorsContainer);
